const CapLogo = ({ className = "!h-24 !w-24 " }) => (
  <div className="relative">
    <div className={`${className}`}>
      <div className="absolute h-24 !w-24 -top-[14px] -left-4">
        <svg
          width="133"
          height="132"
          viewBox="0 0 133 132"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_d_42_2497)">
            <rect
              x="16.3335"
              y="14"
              width="95.8289"
              height="96"
              rx="20"
              fill="white"
            />
            <path
              d="M50.4805 57.418C49.9336 57.418 49.4453 57.5352 49.0156 57.7695C48.5859 57.9961 48.2188 58.3281 47.9141 58.7656C47.6094 59.2031 47.375 59.7383 47.2109 60.3711C47.0547 60.9961 46.9766 61.707 46.9766 62.5039C46.9766 63.582 47.1133 64.4883 47.3867 65.2227C47.6602 65.957 48.0742 66.5117 48.6289 66.8867C49.1914 67.2617 49.8945 67.4492 50.7383 67.4492C51.5039 67.4492 52.2383 67.3438 52.9414 67.1328C53.6523 66.9219 54.3672 66.668 55.0859 66.3711V70.2852C54.3281 70.6211 53.5508 70.8633 52.7539 71.0117C51.9648 71.1602 51.125 71.2344 50.2344 71.2344C48.375 71.2344 46.8516 70.8672 45.6641 70.1328C44.4844 69.3906 43.6133 68.3633 43.0508 67.0508C42.4961 65.7383 42.2188 64.2148 42.2188 62.4805C42.2188 61.1836 42.3984 59.9961 42.7578 58.918C43.125 57.8398 43.6602 56.9062 44.3633 56.1172C45.0664 55.3203 45.9336 54.707 46.9648 54.2773C48.0039 53.8398 49.1914 53.6211 50.5273 53.6211C51.3555 53.6211 52.2266 53.7188 53.1406 53.9141C54.0625 54.1016 54.9609 54.4062 55.8359 54.8281L54.418 58.4727C53.793 58.1758 53.1602 57.9258 52.5195 57.7227C51.8789 57.5195 51.1992 57.418 50.4805 57.418ZM68.9492 71L68.1055 67.7891H62.5391L61.6719 71H56.5859L62.1758 53.7969H68.3516L74.0117 71H68.9492ZM67.1445 63.9922L66.4062 61.1797C66.3281 60.875 66.2148 60.4414 66.0664 59.8789C65.918 59.3086 65.7695 58.7227 65.6211 58.1211C65.4805 57.5117 65.3711 57.0117 65.293 56.6211C65.2227 57.0117 65.1211 57.4961 64.9883 58.0742C64.8633 58.6445 64.7305 59.2109 64.5898 59.7734C64.457 60.3359 64.3398 60.8047 64.2383 61.1797L63.5 63.9922H67.1445ZM81.8047 53.8672C83.9766 53.8672 85.6016 54.3398 86.6797 55.2852C87.7656 56.2305 88.3086 57.5742 88.3086 59.3164C88.3086 60.0977 88.1953 60.8477 87.9688 61.5664C87.75 62.2852 87.3867 62.9258 86.8789 63.4883C86.3789 64.0508 85.7109 64.4961 84.875 64.8242C84.0469 65.1523 83.0234 65.3164 81.8047 65.3164H80.5039V71H75.875V53.8672H81.8047ZM81.6992 57.6055H80.5039V61.543H81.418C81.8164 61.543 82.1875 61.4766 82.5312 61.3438C82.875 61.2031 83.1484 60.9805 83.3516 60.6758C83.5625 60.3633 83.668 59.9492 83.668 59.4336C83.668 58.8945 83.5078 58.457 83.1875 58.1211C82.8672 57.7773 82.3711 57.6055 81.6992 57.6055Z"
              fill="#122670"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_42_2497"
              x="0.333496"
              y="0"
              width="131.829"
              height="132"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feMorphology
                radius="2"
                operator="dilate"
                in="SourceAlpha"
                result="effect1_dropShadow_42_2497"
              />
              <feOffset dx="2" dy="4" />
              <feGaussianBlur stdDeviation="8" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.0862745 0 0 0 0 0.0862745 0 0 0 0 0.0862745 0 0 0 0.1 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_42_2497"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_42_2497"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      </div>
    </div>
  </div>
);
export default CapLogo;
